var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 60C46.5686 60 60 46.5686 60 30C60 13.4315 46.5686 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5686 13.4315 60 30 60Z",
    fill: "#40BF91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3594 30.7321L17.7123 24.719L26.4836 32.7974L43.7515 16.549L50.0261 22.4837L26.3921 44.9151L11.3594 30.7321Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModalIcon);
export default __webpack_public_path__ + "static/media/success-modal-icon.f85394c5f25e9adab36080090fed73f5.svg";
export { ForwardRef as ReactComponent };